export default __webpack_public_path__ + "static/media/WiCyS.08404ec7.svg";